import { render, staticRenderFns } from "./air.vue?vue&type=template&id=5a310407&scoped=true&"
import script from "./air.vue?vue&type=script&lang=js&"
export * from "./air.vue?vue&type=script&lang=js&"
import style0 from "./air.vue?vue&type=style&index=0&id=5a310407&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a310407",
  null
  
)

export default component.exports